import {PRICE as DEFAULT_PRICE} from '../../../fixtures';

export default ({
  keys,
  server,
  activePrice,
  formattedActivePriceAmount,
}) => `<!DOCTYPE html>
<html>
  <head>
    <title>Buy cool new product</title>
    <link rel="stylesheet" href="style.css">
    <script src="https://polyfill.io/v3/polyfill.min.js?version=3.52.1&features=fetch"></script>
    {+load-stripe}
    <script src="https://js.stripe.com/v3/"></script>
    {/load-stripe}
  </head>
  <body>
    <section>
      {+preview-page}
      <div class="product">
        <img
          src="https://i.imgur.com/EHyR2nP.png"
          alt="The cover of Stubborn Attachments"
        />
        <div class="description">
          <h3>${(activePrice || DEFAULT_PRICE)?.product.name}</h3>
          <h5>${formattedActivePriceAmount ||
            DEFAULT_PRICE.formattedActivePriceAmount}</h5>
        </div>
      </div>
      {/preview-page}
      {+add-button}
      <form action="/create-checkout-session${
        server === 'php' ? '.php' : ''
      }" method="POST">
        <button type="submit" id="checkout-button">Checkout</button>
      </form>
      {/add-button}
    </section>
  </body>
</html>`;
